module.exports = __webpack_public_path__ + "static/step6-c528fa4110fb74d7defbcb80f7e90ef0.png";